var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFineArt = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Photo-Frame-Human--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Photo Frame Human Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M21.5 2.5A2.5 2.5 0 0 0 19 0H5a2.5 2.5 0 0 0 -2.5 2.5v19A2.5 2.5 0 0 0 5 24h14a2.5 2.5 0 0 0 2.5 -2.5ZM5 3.5a1 1 0 0 1 1 -1h12a1 1 0 0 1 1 1v17a1 1 0 0 1 -1 1H6a1 1 0 0 1 -1 -1Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.11 13.5h0.67a0.25 0.25 0 0 1 0.25 0.25v0.75a1 1 0 0 0 1 1h2a0.25 0.25 0 0 1 0.21 0.12 0.25 0.25 0 0 1 0 0.24 1 1 0 0 1 -0.25 0.36 2.22 2.22 0 0 1 -1.59 0.29 3 3 0 0 0 -0.53 0 1 1 0 0 0 -0.89 1 3.64 3.64 0 0 0 1.27 2.73 1 1 0 0 0 1.38 -1.45 0.19 0.19 0 0 1 0 -0.19 0.22 0.22 0 0 1 0.15 -0.13 3.12 3.12 0 0 0 1.63 -0.78 4.2 4.2 0 0 0 1.12 -3.18 1 1 0 0 0 -1 -1h-2.25a0.25 0.25 0 0 1 -0.25 -0.25v-0.76a1 1 0 0 0 -1 -1h-0.79a0.24 0.24 0 0 1 -0.24 -0.12 0.25 0.25 0 0 1 0 -0.25l1.39 -2.67a1 1 0 0 0 0.14 -0.46 6.78 6.78 0 0 1 0.32 -2.22 1 1 0 0 0 -0.59 -1.28A1 1 0 0 0 9 5.07a8.31 8.31 0 0 0 -0.44 2.68l-1.79 3.38a1.56 1.56 0 0 0 -0.09 1.61 1.59 1.59 0 0 0 1.43 0.76Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 9h1.41a1 1 0 0 0 0 -2H13a1 1 0 0 0 0 2Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFineArt);
export default ForwardRef;